import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';

interface VideoCardProps {
  video: Video;
  size?: 'small' | 'medium' | 'large';
}

export default function VideoCard({ video, size = 'medium' }: VideoCardProps) {
  const aspectClass = size === 'large' ? 'aspect-[16/9]' : size === 'small' ? 'aspect-[4/3]' : 'aspect-[16/9]';

  return (
    <Link
      to={`/article/${video.id}`}
      className="group block rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
      onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
    >
      <div className={`relative ${aspectClass} overflow-hidden`}>
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`${video.title} - 91视频网站高清在线观看`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-foreground-950/20 group-hover:bg-foreground-950/10 transition-colors"></div>
        <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-foreground-950/70 rounded text-xs text-background-50 font-label">
          {video.duration}
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <div className={`p-3 ${size === 'small' ? 'p-2.5' : 'p-3'}`}>
        <h3 className={`font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors ${size === 'small' ? 'text-xs' : 'text-sm'}`}>
          {video.title}
        </h3>
        <div className={`flex items-center gap-3 mt-2 text-foreground-500 ${size === 'small' ? 'text-[10px]' : 'text-xs'}`}>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {video.views}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500"></i>
            {video.rating}
          </span>
        </div>
      </div>
    </Link>
  );
}